export default __webpack_public_path__ + "static/media/schwalmeder_dark.451b84b1.png";